import {setupSecrets} from './shared/secrets';
import {utilityApps,applyDisplay} from './shared/desktop-apps';
import { playSound, soundEnabled, setSoundEnabled } from './shared/audio';
import gsap from "gsap";
import { Draggable } from "gsap/Draggable";
import { icon, glyph } from "./shared/icons";
import { sections as sharedSections, projectContent, bindContent, homeContent, experienceDetail, experience, projects } from "./shared/content";
import { reducedMotion as reduced } from "./shared/motion";
import "./shared/base.scss";
import "./desktop.scss";
import { setupStartup } from "./startup";
import { resizeWindow } from "./shared/window-geometry";


import { creativeApps, stopApp, activateApp } from './shared/playground';
const {sound: unusedSound, ...professionalSections} = sharedSections;
const sections = {...professionalSections, ...creativeApps, ...utilityApps};
applyDisplay();
sections.work.label="Projects";
sections.about.label="About me";
sections.experience.label="Experience";
sections.contact.label="Contact";
for (const role of experience) sections[`role-${role.id}`] = {label:role.shortName || role.name,title:role.shortName || role.name,experienceId:role.id,render:()=>experienceDetail(role.id)};
const launchers = ['experience', 'about', 'contact', 'work', 'playground', 'calculator', 'notes', 'paint', 'clock', 'settings'].map(id=>[id,sections[id]]);
gsap.registerPlugin(Draggable);
const desktop = document.querySelector("#desktop");
const root = document.querySelector("#windows");
const taskButtons = document.querySelector("#task-buttons");
const mobile = matchMedia("(max-width: 760px)");
const windows = new Map();
let zIndex = 10;
let active = null;
let desktopSnapshot = null;

document.querySelector(".desktop-apps").innerHTML = launchers
  .map(
    ([id, s]) =>
      `<button class="desktop-app" data-open="${id}">${icon(id)}<span>${s.label}</span></button>`,
  )
  .join("");
document.querySelector("#start-button").innerHTML = `<span class="alex-orb" aria-hidden="true">a</span><span>alex</span>`;
document.querySelector("#show-desktop").innerHTML = glyph("home");
document.querySelector("#start-menu").innerHTML =
  `<button class="start-profile" data-open="welcome" aria-label="Open Alexander’s Home"><img src="/img/alex-risio.webp" alt=""><span>Alexander Risio<small>Home</small></span></button>${launchers
    .map(
      ([id, s]) =>
        `<button data-open="${id}">${icon(id)}<span>${s.label}</span>${glyph("arrow")}</button>`,
    )
    .join(
      "",
    )}<button type="button" data-fullscreen>${icon("browser")}<span data-fullscreen-label>Full screen</span>${glyph("maximize")}</button><button type="button" data-startup-replay>${icon("browser")}<span>Replay startup</span>${glyph("play")}</button><a href="/concepts/credits.html">Credits ${glyph("external")}</a>`;

const welcome = homeContent;

function focusWindow(id, focusContent = false) {
  const entry = windows.get(id);
  if (!entry) return;
  desktopSnapshot = null;
  active = id;
  history.replaceState(null, '', id === 'welcome' ? location.pathname + location.search : entry.experience ? `#experience/${entry.experience}` : `#${id}${entry.project ? '/' + entry.project : ''}`);
  entry.minimized = false;
  entry.el.hidden = false;
  positionWindowBounds(entry);
  entry.el.style.zIndex = ++zIndex;
  windows.forEach((win, key) => {
    if (key !== id) stopApp(win.el);
    else activateApp(win.el);
    win.el.classList.toggle("is-active", key === id);
    win.task.classList.toggle("is-active", key === id);
    win.task.setAttribute("aria-pressed", String(key === id && !win.minimized));
    if (mobile.matches && key !== id) win.el.hidden = true;
  });
  if (taskButtons.scrollWidth > taskButtons.clientWidth) entry.task.scrollIntoView({block: "nearest", inline: "nearest"});
  if (focusContent)
    (entry.el.querySelector("[data-app-focus]")||entry.el.querySelector(".content-scroll")).focus({ preventScroll: true });
}

function renderSection(id, project, role) {
  const entry = windows.get(id);
  if (!entry) return;
  const content = entry.el.querySelector(".content-scroll");
  role ||= sections[id]?.experienceId;
  entry.experience = role;
  content.innerHTML = role ? experienceDetail(role, entry.roleReturn?.id === "welcome" ? "Back to Home" : entry.roleReturn?.id === "about" ? "Back to About me" : "Experience folder") :
    id === "welcome"
      ? welcome()
      : project
        ? projectContent(project)
        : sections[id].render();
  content.scrollTop = 0;
  entry.project = project;
  const backLabel = role ? experience.find(p => p.id === role)?.name || "Experience" : project
    ? "Project details"
    : sections[id]?.title || "Welcome";
  entry.el.querySelector(".window-status").textContent =
    id === "work" && !project
      ? `${projects.length} projects`
      : backLabel;
}

function windowSize(entry) {
  const hidden=entry.el.hidden;
  const visibility=entry.el.style.visibility;
  if(hidden){entry.el.style.visibility='hidden';entry.el.hidden=false;}
  const size={width:entry.el.offsetWidth,height:entry.el.offsetHeight};
  if(hidden){entry.el.hidden=true;entry.el.style.visibility=visibility;}
  return size;
}
function positionWindow(entry, id) {
  if (mobile.matches) {
    entry.drag?.disable();
    gsap.set(entry.el, { x: 0, y: 0 });
    return;
  }
  entry.drag?.enable();
  if (entry.maximized) return;
  const rect = desktop.getBoundingClientRect();
  const {width,height} = windowSize(entry);
  let preferredX = id === "welcome"
    ? Math.max(132, (rect.width - width) / 2 + 25)
    : Math.max(150, (rect.width - width) / 2 + 55 + (id === "work" ? 0 : 24));
  let preferredY =
    id === "welcome"
      ? Math.max(64, (rect.height - height) / 2)
      : 85 + (id === "work" ? 0 : 24);
  if (sections[id]?.experienceId) {
    const offset=experience.findIndex(role=>role.id===sections[id].experienceId)*16;
    preferredX+=offset;
    preferredY+=offset;
  }
  if (rect.width >= 1200 && (id === 'welcome' || id === 'experience')) {
    const start = Math.max(155,(rect.width - 1040) / 2);
    preferredX = id === 'welcome' ? start : start + 390;
    preferredY = id === 'welcome' ? 90 : 125;
  }
  gsap.set(entry.el, {
    x: Math.max(12, Math.min(preferredX, rect.width - width - 18)),
    y: Math.max(58, Math.min(preferredY, rect.height - height - 12)),
  });
  entry.drag?.applyBounds({
    minX: 8,
    minY: 58,
    maxX: Math.max(8, rect.width - width - 8),
    maxY: Math.max(58, rect.height - height - 8),
  });
}

function openWindow(id, options = {}) {
  if (["sound","runner","kitchen","woodland"].includes(id)) return openWindow("playground", {...options, activity:id === "woodland" ? null : id});
  if (!(id in sections) && id !== "welcome") return;
  document.querySelector("#start-menu").hidden = true;
  document
    .querySelector("#start-button")
    .setAttribute("aria-expanded", "false");
  if(options.animate!==false)playSound("open");
  const existing = windows.get(id);
  if (existing) {
    if (options.project !== undefined || options.experience !== undefined || options.overview) renderSection(id, options.project, options.experience);
    focusWindow(id, options.focus !== false);
    if(options.activity) existing.el.querySelector("iframe")?.contentWindow?.postMessage({type:"world-launch",id:options.activity},location.origin);
    return;
  }
  const el = document.createElement("section");
  el.className = `desktop-window window-${id}${sections[id]?.experienceId ? " window-role" : ""}`;
  el.setAttribute(
    "aria-label",
    id === "welcome" ? "Alexander Risio — Home" : sections[id].title,
  );
  const title = id === "welcome" ? "Alexander Risio — Home" : sections[id].title;
  const windowIcon = icon(sections[id]?.experienceId ? "experience" : id === "welcome" ? "notes" : id);
  el.innerHTML = `<div class="window-titlebar"><button class="window-menu-button" aria-label="Window menu for ${title}" aria-haspopup="menu">${windowIcon}</button><span class="window-title">${title}</span><div class="window-controls"><button data-control="minimize" aria-label="Minimize ${title}">${glyph("minimize")}</button><button data-control="maximize" aria-label="Maximize ${title}">${glyph("maximize")}</button><button data-control="close" aria-label="Close ${title}">${glyph("close")}</button></div></div><div class="explorer-toolbar"><button data-open="welcome" aria-label="Go to Home">${glyph("home")}</button><span class="window-location">${icon("browser")}Alexander Risio ${glyph("arrow")} ${id === "welcome" ? "Home" : sections[id].label}</span></div><div class="window-inner"><div class="content-scroll" tabindex="-1"></div><div class="window-status"></div></div>`;
  root.append(el);
  const task = document.createElement("button");
  task.className = "task-button";
  task.innerHTML = `${windowIcon}<span>${title}</span>`;
  task.setAttribute("aria-label", `Restore ${title}`);
  taskButtons.append(task);
  const entry = {
    el,
    task,
    minimized: false,
    maximized: false,
    pendingActivity: options.activity || null,
    opener: options.opener || document.querySelector(`[data-open="${id}"]`),
  };
  windows.set(id, entry);
  renderSection(id, options.project, options.experience);

  const drag = Draggable.create(el, {
    type: "x,y",
    trigger: el.querySelector(".window-title"),
    cursor: "default",
    activeCursor: "grabbing",
    minimumMovement: 4,
    onPress: () => focusWindow(id),
  })[0];
  entry.drag = drag;
  positionWindow(entry, id);
  installResize(entry, id);
  bindContent(
    el.querySelector(".content-scroll"),
    (project) => {
      if (id !== "work") openWindow("work", { project });
      else {
        renderSection("work", project);
        el.querySelector(".content-scroll").focus({ preventScroll: true });
      }
      history.replaceState(null, "", `#work/${project}`);
    },
    () => {
      renderSection("work");
      history.replaceState(null, "", "#work");
      el.querySelector(".content-scroll").focus({ preventScroll: true });
    },
  );
  el.querySelector('.window-menu-button').addEventListener('click',event=>showWindowMenu(id,event.currentTarget));
  for(const target of [el.querySelector('.window-titlebar'),task])target.addEventListener('contextmenu',event=>{event.preventDefault();showWindowMenu(id,target,event.clientX,event.clientY);});
  el.addEventListener("pointerdown", () => focusWindow(id));
  el.addEventListener("focusin", () => {
    if (active !== id) focusWindow(id);
  });
  el.querySelector(".window-title").addEventListener("dblclick", () =>
    toggleMaximize(id),
  );
  el.querySelectorAll("[data-control]").forEach((button) =>
    button.addEventListener("click", () => {
      const action = button.dataset.control;
      if (action === "home") document.querySelector("#show-desktop").click();
      if (action === "close") closeWindow(id);
      if (action === "minimize") minimizeWindow(id);
      if (action === "maximize") toggleMaximize(id);
    }),
  );
  task.addEventListener("click", () => {
    if (!entry.minimized && active === id && !mobile.matches)
      minimizeWindow(id);
    else focusWindow(id, true);
  });
  focusWindow(id, options.focus !== false);
  if (!reduced.matches && options.animate !== false)
    gsap.fromTo(
      el,
      { opacity: 0, scale: 0.98 },
      {
        opacity: 1,
        scale: 1,
        duration: 0.3,
        ease: "power3.out",
        clearProps: "opacity",
      },
    );
}

function chooseNextWindow(id) {
  const next = [...windows.entries()]
    .filter(([key, win]) => key !== id && !win.minimized)
    .sort(
      (a, b) => Number(b[1].el.style.zIndex) - Number(a[1].el.style.zIndex),
    )[0];
  if (next) focusWindow(next[0], true);
  else {
    active = null;
    document.body.classList.remove('game-immersive');
    document.querySelector(`[data-open="${id}"]`)?.focus();
  }
}
function minimizeWindow(id) {
  playSound("close");
  const entry = windows.get(id);
  if (!entry) return;
  stopApp(entry.el);
  entry.minimized = true;
  entry.el.hidden = true;
  entry.task.classList.remove("is-active");
  entry.task.setAttribute("aria-pressed", "false");
  chooseNextWindow(id);
}
function closeWindow(id) {
  playSound("close");
  const entry = windows.get(id);
  if (!entry) return;
  stopApp(entry.el);
  gsap.killTweensOf(entry.el);
  entry.drag.kill();
  entry.resizeAbort?.abort();
  entry.el.remove();
  entry.task.remove();
  windows.delete(id);
  chooseNextWindow(id);
  if (!active) entry.opener?.focus();
}
const fullscreenButton = document.querySelector('[data-fullscreen]');
fullscreenButton.hidden = !document.fullscreenEnabled;
fullscreenButton.addEventListener('click', async () => {
  try {
    if (document.fullscreenElement) await document.exitFullscreen();
    else await document.documentElement.requestFullscreen();
    document.querySelector('#start-menu').hidden = true;
    document.querySelector('#start-button').setAttribute('aria-expanded','false');
  } catch { fullscreenButton.querySelector('[data-fullscreen-label]').textContent = 'Full screen unavailable'; }
});
document.addEventListener('fullscreenchange', () => {
  fullscreenButton.querySelector('[data-fullscreen-label]').textContent = document.fullscreenElement ? 'Exit full screen' : 'Full screen';
});

function toggleMaximize(id) {
  playSound("resize");
  const entry = windows.get(id);
  if (!entry || mobile.matches) return;
  if (!entry.maximized) {
    entry.previous = {
      x: gsap.getProperty(entry.el, "x"),
      y: gsap.getProperty(entry.el, "y"),
    };
    entry.maximized = true;
    entry.el.classList.add("is-maximized");
    entry.drag.disable();
    gsap.set(entry.el, { x: 0, y: 0 });
  } else {
    entry.maximized = false;
    entry.el.classList.remove("is-maximized");
    entry.drag.enable();
    gsap.set(entry.el, entry.previous);
    positionWindowBounds(entry);
  }
  const btn = entry.el.querySelector('[data-control="maximize"]');
  btn.innerHTML = glyph(entry.maximized ? "restore" : "maximize");
  btn.setAttribute(
    "aria-label",
    `${entry.maximized ? "Restore" : "Maximize"} ${id === "welcome" ? "Alexander Risio — Home" : sections[id]?.title || "Home"}`,
  );
}
function positionWindowBounds(entry) {
  if (mobile.matches || entry.maximized) return;
  const {width,height}=windowSize(entry);
  entry.drag.applyBounds({
    minX: 8,
    minY: 58,
    maxX: Math.max(8, desktop.clientWidth - width - 8),
    maxY: Math.max(58, desktop.clientHeight - height - 8),
  });
}

const windowMenu=document.createElement('div');
windowMenu.className='window-system-menu';windowMenu.hidden=true;windowMenu.setAttribute('role','menu');windowMenu.setAttribute('aria-label','Window actions');document.body.append(windowMenu);
let menuWindow=null,menuOpener=null;
function closeWindowMenu(){windowMenu.hidden=true;menuOpener?.focus({preventScroll:true});}
function showWindowMenu(id,opener,x,y){
  const entry=windows.get(id);if(!entry)return;
  menuWindow=id;menuOpener=opener;
  windowMenu.innerHTML=`<button role="menuitem" data-window-action="restore" ${!entry.minimized&&!entry.maximized?'disabled':''}>Restore</button><button role="menuitem" data-window-action="minimize" ${entry.minimized?'disabled':''}>Minimize</button><button role="menuitem" data-window-action="maximize" ${mobile.matches||entry.maximized?'disabled':''}>Maximize</button><button role="menuitem" data-window-action="close">Close <kbd>Ctrl+F4</kbd></button>`;
  windowMenu.hidden=false;
  const r=opener.getBoundingClientRect();
  windowMenu.style.left=`${Math.max(4,Math.min(x??r.left,innerWidth-windowMenu.offsetWidth-4))}px`;
  windowMenu.style.top=`${Math.max(4,Math.min(y??r.bottom,innerHeight-windowMenu.offsetHeight-4))}px`;
  windowMenu.querySelector('button:not(:disabled)').focus({preventScroll:true});
}
windowMenu.addEventListener('click',event=>{
  const action=event.target.closest('[data-window-action]')?.dataset.windowAction;if(!action)return;
  const id=menuWindow,entry=windows.get(id);closeWindowMenu();if(!entry)return;
  if(action==='close')closeWindow(id);
  if(action==='minimize')minimizeWindow(id);
  if(action==='maximize'){focusWindow(id);toggleMaximize(id);}
  if(action==='restore'){if(entry.maximized)toggleMaximize(id);focusWindow(id,true);}
});
windowMenu.addEventListener('keydown',event=>{
  const buttons=[...windowMenu.querySelectorAll('button:not(:disabled)')];
  if(event.key==='Escape'){event.preventDefault();event.stopPropagation();closeWindowMenu();}
  if(['ArrowDown','ArrowUp','Home','End'].includes(event.key)){
    event.preventDefault();const index=buttons.indexOf(document.activeElement);
    buttons[event.key==='Home'?0:event.key==='End'?buttons.length-1:(index+(event.key==='ArrowDown'?1:buttons.length-1))%buttons.length]?.focus();
  }
});
document.addEventListener('pointerdown',event=>{if(!event.target.closest('.window-system-menu,.window-menu-button'))windowMenu.hidden=true;});
window.addEventListener('resize',()=>windowMenu.hidden=true);

function installResize(entry, id) {
  const abort=entry.resizeAbort=new AbortController();
  const area=()=>({width:desktop.clientWidth,height:desktop.clientHeight});
  const rect=()=>({x:Number(gsap.getProperty(entry.el,'x')),y:Number(gsap.getProperty(entry.el,'y')),width:entry.el.offsetWidth,height:entry.el.offsetHeight});
  const apply=next=>{entry.userSized=true;entry.el.style.width=`${next.width}px`;entry.el.style.height=`${next.height}px`;gsap.set(entry.el,{x:next.x,y:next.y});};
  for(const edge of ['n','s','e','w','ne','nw','se','sw']){
    const handle=document.createElement(edge==='se'?'button':'div');
    handle.className=`window-resize resize-${edge}`;
    if(edge==='se'){handle.type='button';handle.setAttribute('aria-label',`Resize ${id==='welcome'?'Home':sections[id].label}`);handle.title='Drag to resize · arrow keys when focused';}
    else handle.setAttribute('aria-hidden','true');
    entry.el.append(handle);
    let origin=null;
    handle.addEventListener('pointerdown',event=>{
      if(event.button!==0||entry.maximized||mobile.matches)return;
      event.preventDefault();event.stopPropagation();focusWindow(id);entry.drag.disable();
      origin={...rect(),clientX:event.clientX,clientY:event.clientY};handle.setPointerCapture(event.pointerId);
    },{signal:abort.signal});
    handle.addEventListener('pointermove',event=>{if(origin)apply(resizeWindow(origin,edge,event.clientX-origin.clientX,event.clientY-origin.clientY,area(),id==='welcome'?640:540));},{signal:abort.signal});
    handle.addEventListener('lostpointercapture',()=>{origin=null;if(!entry.maximized&&!mobile.matches)entry.drag.enable();positionWindowBounds(entry);},{signal:abort.signal});
    handle.addEventListener('pointerup',event=>{if(handle.hasPointerCapture(event.pointerId))handle.releasePointerCapture(event.pointerId);},{signal:abort.signal});
    if(edge==='se')handle.addEventListener('keydown',event=>{
      if(!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(event.key))return;
      event.preventDefault();const step=event.shiftKey?40:10;
      apply(resizeWindow(rect(),'se',event.key==='ArrowLeft'?-step:event.key==='ArrowRight'?step:0,event.key==='ArrowUp'?-step:event.key==='ArrowDown'?step:0,area(),id==='welcome'?640:540));positionWindowBounds(entry);
    },{signal:abort.signal});
  }
}

function showExperience(role, trigger) {
  if (!experience.some(p => p.id === role)) return;
  const sourceEl = trigger.closest('.desktop-window');
  const source = [...windows.entries()].find(([,entry])=>entry.el===sourceEl);
  const id=`role-${role}`;
  const returnTo = source && !source[1].experience ? { id:source[0], scroll:source[1].el.querySelector('.content-scroll').scrollTop, role, trigger } : windows.get(id)?.roleReturn;
  openWindow(id, { opener:trigger });
  const entry=windows.get(id);
  entry.roleReturn=returnTo;
  renderSection(id);
  focusWindow(id,true);
}
function returnFromExperience(trigger) {
  const entry=[...windows.values()].find(win=>win.el===trigger.closest('.desktop-window'));
  const target=entry?.roleReturn;
  if (target && windows.has(target.id)) {
    focusWindow(target.id);
    const source=windows.get(target.id).el.querySelector('.content-scroll');
    source.scrollTop=target.scroll;
    const control=target.trigger?.isConnected ? target.trigger : source.querySelector(`[data-experience="${target.role}"]`);
    control?.focus({preventScroll:true});
  } else openWindow('experience',{overview:true});
}
function selectProfileTab(tab) {
  const group=tab.closest('.personal-properties');
  for(const button of group.querySelectorAll('[role="tab"]')) {
    const selected=button===tab;
    button.setAttribute('aria-selected',String(selected));
    button.tabIndex=selected?0:-1;
    group.querySelector(`#${button.getAttribute('aria-controls')}`).hidden=!selected;
  }
  tab.focus({preventScroll:true});
}
document.addEventListener('keydown',event=>{
  const tab=event.target.closest('[data-profile-tab]');
  if(!tab||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
  event.preventDefault();event.stopPropagation();
  const tabs=[...tab.parentElement.querySelectorAll('[role="tab"]')];
  const index=tabs.indexOf(tab);
  selectProfileTab(tabs[event.key==='Home'?0:event.key==='End'?tabs.length-1:(index+(event.key==='ArrowRight'?1:tabs.length-1))%tabs.length]);
});

document.addEventListener("click", (e) => {
  const role = e.target.closest("[data-experience]");
  if (role) showExperience(role.dataset.experience, role);
  if (e.target.closest("[data-back-experience]")) returnFromExperience(e.target.closest("[data-back-experience]"));
  const tab=e.target.closest("[data-profile-tab]");
  if(tab)selectProfileTab(tab);
  const btn = e.target.closest("[data-open]");
  if (btn) {
    openWindow(btn.dataset.open, { opener: btn, overview: btn.dataset.open === "experience" || btn.dataset.open === "work" });
    history.replaceState(null, "", `#${btn.dataset.open}`);
  }
  if (!e.target.closest("#start-menu,#start-button")) {
    document.querySelector("#start-menu").hidden = true;
    document
      .querySelector("#start-button")
      .setAttribute("aria-expanded", "false");
  }
});
document.querySelector("#start-button").addEventListener("click", () => {
  const menu = document.querySelector("#start-menu");
  menu.hidden = !menu.hidden;
  document
    .querySelector("#start-button")
    .setAttribute("aria-expanded", String(!menu.hidden));
  if (!menu.hidden) menu.querySelector("button").focus();
});
document.querySelector('#start-menu').addEventListener('keydown',event=>{
  if(!['ArrowDown','ArrowUp','Home','End'].includes(event.key))return;
  event.preventDefault();const items=[...event.currentTarget.querySelectorAll('button:not([hidden]),a')];const current=items.indexOf(document.activeElement);
  items[event.key==='Home'?0:event.key==='End'?items.length-1:(current+(event.key==='ArrowDown'?1:items.length-1))%items.length]?.focus();
});
document.querySelector("#show-desktop").addEventListener("click", () => {
  if (desktopSnapshot) {
    const saved = desktopSnapshot;
    desktopSnapshot = null;
    saved.ids.forEach(id => { const entry=windows.get(id); if(entry){entry.minimized=false;entry.el.hidden=false;} });
    if (windows.has(saved.active)) focusWindow(saved.active);
    else if (saved.ids.length) focusWindow(saved.ids.at(-1));
    return;
  }
  const ids=[...windows.keys()].filter(id=>!windows.get(id).minimized);
  if(!ids.length)return;
  desktopSnapshot={ids,active};
  ids.forEach(id=>{const entry=windows.get(id);stopApp(entry.el);entry.minimized=true;entry.el.hidden=true;entry.task.classList.remove('is-active');entry.task.setAttribute('aria-pressed','false');});
  active=null;
  document.body.classList.remove('game-immersive');
});
document.addEventListener("keydown", (e) => {
  if (document.querySelector("#startup-screen")?.open) return;
  if (e.key === "Escape") {
    const menu = document.querySelector("#start-menu");
    if (!menu.hidden) {
      menu.hidden = true;
      document
        .querySelector("#start-button")
        .setAttribute("aria-expanded", "false");
      document.querySelector("#start-button").focus();
    }
  }
  if(e.ctrlKey && e.key === "F4" && active){e.preventDefault();closeWindow(active);}
  if(e.key === "F6" && windows.size){
    e.preventDefault();
    const ids=[...windows.keys()].filter(id=>!windows.get(id).minimized);
    if(ids.length)focusWindow(ids[(ids.indexOf(active)+(e.shiftKey?ids.length-1:1))%ids.length],true);
  }
});
window.addEventListener("resize", () => windows.forEach(entry => {
  if(entry.userSized && !mobile.matches && !entry.maximized){
    const {width,height}=windowSize(entry);
    entry.el.style.width=`${Math.min(width,desktop.clientWidth-16)}px`;
    entry.el.style.height=`${Math.min(height,desktop.clientHeight-66)}px`;
  }
  positionWindowBounds(entry);
}));
mobile.addEventListener("change", () => {
  windows.forEach((entry, id) => {
    entry.el.classList.remove("is-maximized");
    entry.maximized = false;
    const maximize = entry.el.querySelector('[data-control="maximize"]');
    maximize.innerHTML = glyph("maximize");
    maximize.setAttribute("aria-label", `Maximize ${id === "welcome" ? "Alexander Risio — Home" : sections[id].title}`);
    positionWindow(entry, id);
    entry.el.hidden = entry.minimized;
  });
  if (active) focusWindow(active);
});
function updateClock() {
  document.querySelector("#clock").innerHTML =
    `${new Date().toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })}<span>${new Date().toLocaleDateString([], { month: "short", day: "numeric" })}</span>`;
}
updateClock();
setInterval(updateClock, 30000);
window.addEventListener('message', event => {
  const woodland = windows.get('playground');
  if (event.origin !== location.origin || event.source !== woodland?.el.querySelector('iframe')?.contentWindow) return;
  if(event.data?.type==='woodland-desktop'){closeWindow('playground');openWindow('welcome');return;}
  if (event.data?.type === 'woodland-focus' && active !== 'playground') focusWindow('playground');
  if (event.data?.type === 'woodland-open' && sharedSections[event.data.id]) openWindow(event.data.id);
  if (event.data?.type === 'woodland-ready') {
    if (woodland.pendingActivity) {
      event.source.postMessage({type:'world-launch',id:woodland.pendingActivity},location.origin);
      woodland.pendingActivity = null;
    }
    (active === 'playground' && !woodland.minimized ? activateApp : stopApp)(woodland.el);
  }
});
let entered = false;
setupStartup({
  onEnter() {
    if (entered) return;
    history.replaceState(null, '', location.pathname + location.search);
    document.body.classList.add("desktop-ready");
    try {
      if (innerWidth >= 1200) openWindow("experience", { focus: false, animate: false });
      openWindow("welcome", { focus: true, animate: false });
      document.querySelector("#static-profile")?.setAttribute("hidden", "");
      entered = true;
    } catch (error) {
      document.body.classList.remove("desktop-ready");
      throw error;
    }
  },
  onSuspend() {
    windows.forEach(entry => stopApp(entry.el));
    document.querySelector("#start-menu").hidden = true;
    document.querySelector("#start-button").setAttribute("aria-expanded", "false");
  },
  onResume() {
    if (active) focusWindow(active, true);
  },
});

const soundToggle=document.querySelector('#desktop-sound');
function syncSoundToggle(){soundToggle.innerHTML=glyph('sound');soundToggle.setAttribute('aria-label',soundEnabled()?'Mute all sounds':'Unmute sounds');soundToggle.setAttribute('aria-pressed',String(soundEnabled()));soundToggle.style.opacity=soundEnabled()?'1':'.5';}
soundToggle.addEventListener('click',()=>{setSoundEnabled(!soundEnabled());if(soundEnabled())playSound('select');});
document.addEventListener('portfolio-sound-change',syncSoundToggle);syncSoundToggle();

setupSecrets();
